import { IoIosArrowDroprightCircle } from 'react-icons/io';
import { Link } from 'react-router-dom';

import { Container } from './styles';

interface ISubmenu {
  path: string;
  title: string;
}
interface AsideButtonProps {
  icon: string | JSX.Element;
  title: string;
  submenu?: ISubmenu[];
  active?: string;
  submenuOpen: boolean;
  onSubmenuToggle: () => void;
  onCloseSubmenu: () => void;
}

export const AsideButton: React.FC<AsideButtonProps> = ({
  title,
  icon,
  submenu,
  active,
  submenuOpen,
  onSubmenuToggle,
  onCloseSubmenu,
}) => (
  <Container>
    <li className={`menu ${active ? active : ''}`}>
      {submenu?.length ? (
        <button
          type="button"
          className="menuTrigger"
          aria-label={title}
          aria-expanded={submenuOpen}
          title={title}
          onClick={onSubmenuToggle}
        >
          <div>{icon}</div>
          <p>{title}</p>
        </button>
      ) : (
        <>
          <div>{icon}</div>
          <p>{title}</p>
        </>
      )}
      {submenu?.length ? (
        <ul className="submenu" data-open={submenuOpen}>
          {submenu.map((sub) => (
            <li key={sub.path}>
              <Link to={sub.path} onClick={onCloseSubmenu}>
                <IoIosArrowDroprightCircle height={15} />
                {sub.title}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </li>
  </Container>
);
